export default class AuthResponse {
    // #region Properties
    isSucceded = false;
    errorCode = "";
    errorMessage = "";
    customData = {};
    token;
    redirectUrl;
    // #endregion
    // #region Constructor
    constructor(init) {
        Object.assign(this, init);
    }
}
